module.exports = __webpack_public_path__ + "img/icon-check-small.e5f115a6.svg";